import { Carservice } from '../model/carservice';
import { ImageGalleryBuilder } from "./image-gallery-builder";
export class CarServiceBuilder {
    static buildCarService(data) {
        const carService = new Carservice();
        carService.id = data.id;
        carService.id_carservice_family = data.id_car_service_family;
        carService.name_es = data.name_es;
        carService.name_ca = data.name_ca;
        carService.name_en = data.name_en;
        carService.name_fr = data.name_fr;
        carService.description_es = data.description_es;
        carService.description_ca = data.description_ca;
        carService.description_en = data.description_en;
        carService.description_fr = data.description_fr;
        carService.long_description_es = data.long_description_es;
        carService.long_description_ca = data.long_description_ca;
        carService.long_description_en = data.long_description_en;
        carService.long_description_fr = data.long_description_fr;
        carService.icon = data.icon;
        carService.image_gallery = data.image_gallery ? ImageGalleryBuilder.buildImageGallery(data.image_gallery) : null;
        carService.is_active = data.is_active;
        carService.umc_required = data.umc_required;
        carService.motor_applicabilitycode_required = data.motor_applicabilitycode_required;
        carService.body_applicabilitycode_required = data.body_applicabilitycode_required;
        carService.request_km = data.request_km;
        carService.request_brakes = data.request_brakes;
        carService.request_change = data.request_change;
        carService.request_battery = data.request_battery;
        carService.min_hours_from_booking_to_checkout = data.min_hours_from_booking_to_checkout;
        carService.sort = data.sort;
        carService.fees_not_included = data.fees_not_included;
        carService._availability_status = data._availability_status;
        carService.warning_before_buy = data.warning_before_buy;
        carService.check_in_es = data.check_in_es;
        carService.check_in_ca = data.check_in_ca;
        carService.check_in_en = data.check_in_en;
        carService.check_in_fr = data.check_in_fr;
        return carService;
    }
}
//# sourceMappingURL=car-service-builder.js.map